<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp istatistik">
    <container class="gen-container">
      <DormDashboardHead
        :first-name="first_name"
        :last-name="last_name"
        :logo="dormLogo"
        :mail="mail1"
      ></DormDashboardHead>
      <div class="user__list-offer">
        <DormRoomAddForm></DormRoomAddForm>
      </div>
    </container>
  </div>
</template>

<script>
import DormDashboardHead from '@/components/Dorm/DormDashboardHead.vue'
import DormRoomAddForm from '@/features/Room/DormRoomAddForm.vue'
import { mapGetters } from 'vuex'

export default {
  components: { DormDashboardHead, DormRoomAddForm },
  metaInfo() {
    return {
      title: 'Oda Ekle'
    }
  },
  data() {
    return {
      dormLogo: null,
      mail: ''
    }
  },
  computed: {
    ...mapGetters(['first_name', 'last_name', 'phone', 'mail1'])
  },
  mounted() {
    this.dormLogo = window.localStorage.getItem('cache:dorm_logo')
    this.mail = window.localStorage.getItem('mail')
    this.username = window.localStorage.getItem('username')
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/components/dorm-room';
</style>
